<div class="flex h-full" [class]="(workspaceId && hasToggleOn$ | async) ? 'w-full' : 'w-full'">
  @if(workspaceId && hasToggleOn$ | async){
  <div class="nav w-[253px]">
    <nav class="w-full">
      <ul class="w-full pt-[60px]">
        <li
          *ngFor="let user of worksapceUsers; let index = index; let last = last"
          class="app__stepper__config-stepitem"
          [ngClass]="{
            'app__stepper__config-stepitem-selected border-l-0': user?.status == 'active',
            block: user.toggle === 'on',
            hidden: user.toggle === 'off'
          }"
          (click)="handleSidenavMenuNavigation(user.user_id, user.toggle, index)"
        >
          {{ user.name }}
        </li>
      </ul>
    </nav>
  </div>
  }
  <div class="h-full" [class]="(workspaceId && hasToggleOn$ | async) ? 'w-[calc(100%-253px)]' : 'w-full'">
    @if(!isFromDiscovery){
    <header class="account__setup--header px-7">
      <p class="font-open-sans text-xl text-[#1E1E20] leading-6 m-0 font-bold flex items-center justify-center">
        Live Data Feeds For Financial Institutions
      </p>
      <button matTooltipPosition="above" data-dismiss="modal" class="bg-white w-6 h-6" (click)="closeSideDrawer()">
        <span class="material-icons relative bg-white text-[#898F9E] w-full h-full">clear</span>
      </button>
    </header>
    }
    <div
      class="w-full overflow-hidden bg-[#FAFAFA]"
      style="height: calc(100% - 4rem)"
      [ngClass]="{ 'py-11': isFromDiscovery, 'py-[42px]': !isFromDiscovery }"
    >
      <div class="h-full">
        <div [ngClass]="{ 'px-0': isFromDiscovery, 'px-[32px]': !isFromDiscovery }">
          <div class="app__centered-item app__form--attribute--title justify-between text-sm" [ngClass]="{ 'w-[794px]': isFromDiscovery }">
            <p class="m-0">
              {{ isFromDiscovery ? 'Financial Integrations' : 'All Connected Financial Institutions' }}
              <span class="text-k-blue">({{ mxDatList().length }})</span>
            </p>
            @if((!workspaceId || worksapceUsers[currentActiveIndex].toggle == 'on') && !isFromDiscovery){
            <div class="flex justify-center gap-2">
              <button class="custom-outline-green-button w-full min-w-fit h-[44px] text-sm font-semibold px-3" (click)="addInstitutionThroughPlaid()">
                Connect with <img class="ml-[6px]" src="/assets/images/plaid-new-black-icon.svg" />
              </button>
              <button class="custom-outline-green-button w-full h-[44px] text-sm font-semibold px-3" (click)="addInstitution()">
                Connect with <img class="h-[16px] ml-[10px]" src="/assets/images/mx-new-black-icon.svg" />
              </button>
            </div>
            }@else if(mxDatList().length > 0){
            <div class="flex justify-center gap-2">
              <button
                class="border border-[#1AA140] bg-[#EFFFF7] text-sm font-semibold text-[#1AA140] rounded-[4px] px-4 py-[5px] flex justify-center items-center gap-[11px]"
                (click)="addInstitutionThroughPlaid()"
              >
                Connect with <img src="/assets/images/plaid-new-black-icon.svg" />
              </button>
              <button
                class="border border-[#1AA140] bg-[#EFFFF7] text-sm font-semibold text-[#1AA140] rounded-[4px] px-4 py-3 flex justify-center items-center gap-[11px]"
                (click)="addInstitution()"
              >
                Connect with <img src="/assets/images/mx-new-black-icon.svg" class="h-[16px]" />
              </button>
            </div>

            }
          </div>
          @if(!isFromDiscovery){
          <div class="app__form--attribute--title flex items-center text-[12px] font-medium gap-2 mt-6">
            <div class="p-4 w-[50%] rounded-[10px] flex items-center justify-between border border-[#6bd489b3] bg-[#F4FFF7]">
              <p class="flex items-center gap-1 m-0">
                <span class="w-[10px] h-[10px] rounded-sm border border-[#5F5F5F] bg-[#6BD489]"></span>
                Connected
              </p>
              <p class="m-0 font-bold">{{ connectedAccounts().length }}</p>
            </div>
            <div class="p-4 w-[50%] rounded-[10px] flex items-center justify-between border border-[#fe8a66b3] bg-[#FDEAE5]">
              <p class="flex items-center gap-1 m-0">
                <span class="w-[10px] h-[10px] rounded-sm border border-[#5F5F5F] bg-[#FE8A66]"></span>
                Disconnected
              </p>
              <p class="m-0 font-bold">{{ disconnectedAccounts().length }}</p>
            </div>
          </div>
          }
        </div>

        @if (!isLoadingData()) {
        <div class="add-subfolder--container w-full m-0 p-0 bg-[#FAFAFA]" [ngClass]="{ 'mt-4': mxDatList().length > 0 }">
          @if (mxDatList().length > 0) {
          <div class="h-full mb-4" [ngClass]="{ 'pr-[16px]': !isFromDiscovery }">
            <div
              class="overflow-y-auto flex flex-col gap-4"
              [ngClass]="{
                'px-0 max-h-[calc(100vh-454px)] w-[812px]': isFromDiscovery && switchFromUser,
                'px-0 max-h-[calc(100vh-402px)] w-[812px]': isFromDiscovery && !switchFromUser,
                'pl-[32px] pb-10 max-h-[80%]': !isFromDiscovery
              }"
            >
              @for (account of mxDatList(); track account; let i = $index) {
              <div class="asset-list-group" [ngClass]="{ 'w-[794px]': isFromDiscovery, 'w-[calc(100%-16px)]': !isFromDiscovery }">
                <div>
                  <mat-accordion>
                    <mat-expansion-panel
                      hideToggle
                      style="border-radius: 10px"
                      [togglePosition]="'before'"
                      (opened)="onPanelOpened(i)"
                      (closed)="onPanelClosed(i)"
                      (mouseenter)="mouseEnterHandler($event, assetExpansionPanel)"
                      #assetExpansionPanel
                      [expanded]="expandedItems().includes(i)"
                      class="institution-accordion-panel"
                    >
                      <!-- HEADER -->
                      <mat-expansion-panel-header [ngClass]="{ 'small-estate-panel': account.connection_status == 'CONNECTED' }" class="estate-panel">
                        <mat-panel-title style="align-items: center; margin: 0">
                          <span class="material-icons open mr-2">chevron_right</span>
                          <span class="material-icons close rotate-90 text-k-black font-normal opacity-100 mr-2">chevron_right</span>
                          <div class="pannel-continer">
                            <div class="header">
                              <div class="left flex items-center">
                                <div class="flex items-center">
                                  <ngx-avatars
                                    size="36"
                                    src="{{ account?.institution?.small_logo_url }}"
                                    name="{{ account?.institution?.name | titlecase }}"
                                    initialsSize="2"
                                    cornerRadius="50"
                                    [round]="false"
                                    class="logo-img"
                                  ></ngx-avatars>
                                </div>
                                <div class="left-sub-div">
                                  <div class="flex items-center">
                                    <div
                                      class="title text-k-black font-semibold text-lg"
                                      [ngClass]="{ 'custom-position': account.connection_status != 'CONNECTED' }"
                                      [matTooltip]="account?.name"
                                    >
                                      {{ account?.name | truncateStrPipe : (+account?.userAccounts?.length == 0 ? 17 : 24)
                                      }}<span class="mx-2">•</span>
                                      @if (+account?.userAccounts?.length > 0) {
                                      <span class="counter"> &nbsp;({{ account?.userAccounts?.length }}) </span>
                                      }
                                    </div>
                                    @if (+account?.userAccounts?.length > 0) {
                                    <div class="sub-title font-normal text-base text-k-black">{{ account?.userAccounts?.length }} Accounts</div>
                                    } @if (+account?.userAccounts?.length == 0) {
                                    <div class="sub-title font-normal text-base text-k-black">No Accounts</div>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="right-div flex items-center">
                                <div class="flex items-center gap-3">
                                  @if (account?.connection_status && account.connection_status !== 'CONNECTED') {
                                  <button
                                    (click)="
                                      $event.stopPropagation();
                                      account?.access_token ? reconnectToTheInstitutionThroughPlaid(account) : addInstitution()
                                    "
                                    class="cursor-pointer flex items-center h-8 bg-k-blue text-white rounded p-2 font-semibold text-[12px] gap-1"
                                  >
                                    <span class="material-icons text-white h-[20px] w-[20px] text-[20px]">refresh</span>
                                    Connect
                                  </button>
                                  }
                                  <img
                                    [src]="
                                      account?.guid ? '/assets/images/mx-financial-institution.svg' : '/assets/images/plaid-financial-institution.svg'
                                    "
                                    [matTooltip]="account?.guid ? 'Connected with MX' : 'Connected with Plaid'"
                                    matTooltipClass="customTooltip"
                                  />
                                  <img
                                    [src]="
                                      account?.connection_status === 'CONNECTED'
                                        ? '/assets/images/financial-institution-connected.svg'
                                        : '/assets/images/financial-institution-disconnected.svg'
                                    "
                                    customTooltip
                                    [customTooltipTitle]="account?.connection_status === 'CONNECTED' ? 'Active Connection' : 'Broken Connection'"
                                    [customTooltipSubtitle]="'Last Updated ' + ((account?.updated_at || account?.created_at) | date : 'MM/dd/yyyy')"
                                  />
                                </div>
                                <div class="popup-menu">
                                  <button
                                    mat-icon-button
                                    [matMenuTriggerFor]="menuItem"
                                    class="mobiel-button h-6 w-6 p-0 flex ml-3"
                                    (click)="$event.stopPropagation()"
                                    [disableRipple]="true"
                                  >
                                    <span class="material-icons" style="transform: rotate(0deg) !important">more_vert</span>
                                  </button>
                                  <mat-menu #menuItem="matMenu" yPosition="below" xPosition="before" class="popup-menu-panel w-[190px]">
                                    <button mat-menu-item class="popup-menu-item" (click)="disconnect(account)">
                                      <div class="flex items-center gap-2">
                                        <span class="material-icons menuitem-icon material-symbols-outlined material-icons-outlined text-xl m-0"
                                          >delete</span
                                        >
                                        <p class="menuitem-text text-sm font-semibold m-0">Delete Connection</p>
                                      </div>
                                    </button>
                                  </mat-menu>
                                </div>
                              </div>
                            </div>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div style="margin: 0 -24px -24px -24px">
                        <individual-user-member
                          [updated_at]="account.updated_at"
                          (someEvent)="handleEmitEvents($event)"
                          [userMembers]="account?.userAccounts"
                          (selectedItemsEmitter)="handleSelectedAccounts($event)"
                          [isFromDiscovery]="isFromDiscovery ? true : false"
                          [selectedItemsArray]="selectedAccounts()"
                        >
                        </individual-user-member>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </div>
              }
            </div>
          </div>
          } @if (mxDatList().length == 0) {
          <div
            class="flex justify-center items-center"
            [ngClass]="{
              'h-[calc(100vh-416px)]': isFromDiscovery && switchFromUser,
              'h-[calc(100vh-364px)]': isFromDiscovery && !switchFromUser,
              'h-[80%]': !isFromDiscovery
            }"
          >
            <div class="flex-center flex-col">
              <img src="assets/images/financial-account__zero-state.svg" alt="No financial accounts connected" class="w-[220px] h-[196px] mb-6" />
              <p class="text-[#53565B] text-lg font-semibold font-open-sans m-0">
                No <span class="text-k-blue font-bold"> {{ isFromDiscovery ? 'Financial Integrations' : 'Financial Accounts' }}</span> to Show
              </p>
              @if(isFromDiscovery){
              <div class="flex justify-center gap-2">
                <button
                  class="border border-[#1AA140] bg-[#EFFFF7] text-sm font-semibold text-[#1AA140] rounded-[4px] px-4 h-[44px] flex justify-center items-center gap-[11px] mt-4"
                  (click)="addInstitutionThroughPlaid()"
                >
                  Connect with <img src="/assets/images/plaid-new-black-icon.svg" />
                </button>
                <button
                  class="border border-[#1AA140] bg-[#EFFFF7] text-sm font-semibold text-[#1AA140] rounded-[4px] px-4 h-[44px] flex justify-center items-center gap-[11px] mt-4"
                  (click)="addInstitution()"
                >
                  Connect with <img src="/assets/images/mx-new-black-icon.svg" class="h-[16px]" />
                </button>
              </div>
              }
            </div>
          </div>
          }
        </div>
        } @else {
        <div class="loader-container mt-3 flex-col" [ngClass]="{ 'px-0 w-[794px]': isFromDiscovery, 'px-[32px]': !isFromDiscovery }">
          @for (item of loaderItems; track item) {
          <div class="w-full">
            <div class="flex loader-body w-full" id="{{ item.id }}">
              <div class="ph-item width-100per loader-body-item pt-[20px]">
                <div class="ph-col-12 p-0">
                  <div class="ph-row">
                    <div class="ph-col-12 h-10 p-0 m-0"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="checklist-floater">
  <checklist-floater-action
    [isFromFinancialInstitution]="true"
    [selectedItemsArray]="selectedAccounts()"
    (onMoveClicked)="moveChecklists($event)"
    (onNotInUseClicked)="notInUseChecklists($event)"
    [isFromMXFinancialAccount]="true"
  ></checklist-floater-action>
</div>
